<template>
	<div 
		class="input-group"
		:class="{
			'no-line': noLine,
			'flex-input-block': flexInputBlock,
			'dark-mode': darkMode,
			'condensed': condensed,
			'one-column': oneColumn,
			'fixed-to-bottom': fixedToBottom
		}"
		>
		<div class="description-block" v-if="title">
			<div class="title">
				{{ title }}
			</div>
			<div class="desc" v-html="desc" />
		</div>
		<div 
			class="input-block"
			:class="{
				'skip-white-container': skipWhiteBox,
				'button-box': buttonBox
			}"
			>
			<slot></slot>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		title: String,
		desc: String,
		skipWhiteBox: Boolean,
		noLine: Boolean,
		flexInputBlock: Boolean,
		darkMode: Boolean,
		condensed: Boolean,
		buttonBox: Boolean,
		oneColumn: Boolean,
		fixedToBottom: Boolean
	}
}

</script>

<style lang="sass">

.input-group
	display: grid
	grid-template-columns: 0.35fr 1fr
	grid-column-gap: 50px
	padding-bottom: 30px
	margin-bottom: 30px
	border-bottom: 1px solid rgba(#000,0.1)
	position: relative
	grid-column-gap: 0

	@media (max-width: 980px)
		display: flex
		flex-direction: column
		gap: 15px

	&.one-column
		display: flex
		flex-direction: column
		gap: 15px

	&.fixed-to-bottom
		position: fixed
		bottom: 0
		left: 0
		right: 0
		z-index: 9999
		padding: 25px
		border-top: 1px solid rgba(#fff, 0.4)
		gap: 0
		margin-bottom: 0
		background-color: rgba(#181818, 0.7)
		backdrop-filter: blur(7px)

		.button, .button-container
			width: 100%

	&.no-line
		border-bottom: none

	.description-block
		padding-right: 25px
		
		.title
			font-family: 'Roboto Condensed', sans-serif
			font-weight: 700
			font-size: 22px
			line-height: 1.1
			color: #252525
			margin-bottom: 10px

		.desc
			font-family: 'Roboto', sans-serif
			font-weight: 400
			font-size: 16px
			line-height: 1.4
			color: #6a6a6a

			a
				text-decoration: underline

				&:hover
					color: #000

	.input-block
		border-radius: 6px
		box-shadow: 0 1px 3px rgba(#000, 0.12)
		padding: 25px 25px
		background-color: #fff

		&.skip-white-container
			padding: 0
			box-shadow: none
			background: transparent

		div
			&:last-child
				margin-bottom: 0

		&.button-box
			gap: 20px
			display: flex

	&.flex-input-block
		.input-block
			display: flex

	&.dark-mode
		border-bottom: 1px solid rgba(#fff,0.2)

		.description-block
			.title
				color: rgba(#fff, 0.9)
				font-size: 18px

			.desc
				color: rgba(#fff, 0.7)
				font-size: 14px

		.input-block
			background-color: rgba(#fff, 0.1)

			&.skip-white-container
				background: transparent	

	&.condensed
		padding-bottom: 10px
		margin-bottom: 10px


</style>